const makeHandleFirmFilterChange = (get) => (e) => {
  const select = e.target
  const firmId = select.value

  const renderedFirm = document.querySelector(`[data-firm-id~='${firmId}']`)

  if (!renderedFirm) {
    const url = select.options[select.selectedIndex].dataset.targetUrl

    get(url)
  }
}

const handleHideFirmClick = (e) => {
  const firmId = e.target.dataset.firmId

  const element = document.querySelector(`[data-firm-id~='${firmId}']`)
  element.remove()
}

export default ($dom, { get, select2 } = {}) => {
  const firmFilter = $dom[0].querySelector(
    'select[data-behavior~="firm-filterer"]'
  )

  const handleFirmFilterChange = makeHandleFirmFilterChange(get)

  if (firmFilter) {
    select2(firmFilter)

    $dom.on(
      'change',
      '[data-behavior~="firm-filterer"]',
      handleFirmFilterChange
    )

    $dom.on(
      'click',
      '[data-behavior~="hide-filtered-firm"]',
      handleHideFirmClick
    )
  }

  return () => {
    $dom.off(
      'change',
      '[data-behavior~="firm-filterer"]',
      handleFirmFilterChange
    )

    $dom.off(
      'click',
      '[data-behavior~="hide-filtered-firm"]',
      handleHideFirmClick
    )
  }
}
